import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { TitlesPage } from '@/features/profiles'

export const Route = createFileRoute('/_authenticated/_main/titulos/')({
  head: () => ({
    meta: [{ title: buildPageTitle('Meus Títulos') }]
  }),
  component: TitlesPage
})
